/**
 * Grocera — rândurile de subcategorii de pe pagina de raion se construiesc pe rând.
 *
 * Tema randează toate rândurile deodată: zece produse fiecare, plus un carusel Swiper
 * per rând, toate pornite la încărcare. Pe un raion cu douăzeci de subcategorii asta
 * înseamnă două sute de carduri și douăzeci de carusele înainte să apuci să te uiți la
 * primul. De acolo vine greutatea.
 *
 * Aici lăsăm primele rânduri așa cum sunt și pe celelalte scoatem cardurile din pagină,
 * păstrându-le deoparte. Nu le aruncăm: sunt deja venite de la server, deci nu mai
 * costă nicio cerere să le punem înapoi. Un nod scos din pagină nu se așază și nu-și
 * încarcă pozele, deci dispare tot ce era scump. Le punem la loc când te apropii.
 *
 * Nu atingem elementul <subcol-row-carousel> al temei. Îi punem metodele _init și
 * _initLazyLoad direct pe instanță, unde umbresc metodele din prototip, și le ștergem
 * când vine rândul lui — așa caruselul pornește exact atunci, nu mai devreme.
 */
(function () {
  if (window.__subcolDefer) return;
  window.__subcolDefer = true;

  var EAGER = 3; // câte rânduri rămân randate de la bun început
  var MARGIN = '900px 0px'; // cât de devreme pregătim rândul care urmează

  function noop() {}

  function rows() {
    return Array.prototype.slice.call(document.querySelectorAll('subcol-row-carousel'));
  }

  function reserve(el, h) {
    el.style.minHeight = h + 'px';
  }

  function wake(el) {
    if (!el._deferStash) return;
    try {
      delete el._init;
      delete el._initLazyLoad;
      var box = el.querySelector('.subcol-row__products');
      if (box) {
        var frag = document.createDocumentFragment();
        el._deferStash.forEach(function (n) {
          frag.appendChild(n);
        });
        box.appendChild(frag);
      }
      el._deferStash = null;
      el.style.minHeight = '';
      el.removeAttribute('data-subcol-deferred');
      // _wrap e pus de connectedCallback al temei; dacă încă n-a apucat, îl punem noi
      if (!el._wrap) el._wrap = el.closest('.subcol-row__slider-wrap');
      if (typeof el._init === 'function') el._init();
      if (typeof el._initLazyLoad === 'function') el._initLazyLoad();
      if (el._slider && el._slider.slider && typeof el._slider.slider.update === 'function') {
        el._slider.slider.update();
      }
    } catch (e) {
      /* dacă ceva nu merge, rândul rămâne cu produsele puse la loc — tot e vizibil */
    }
  }

  function sleep(el, h) {
    var items = Array.prototype.slice.call(el.querySelectorAll('.subcol-row__product-item'));
    if (!items.length) return false;
    // dacă tema a apucat deja să pornească caruselul, îl oprim înainte să scoatem slide-urile
    try {
      if (el._slider && typeof el._destroy === 'function') el._destroy();
    } catch (e) {
      /* noop */
    }
    items.forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    el._deferStash = items;
    el._init = noop;
    el._initLazyLoad = noop;
    el.setAttribute('data-subcol-deferred', '');
    reserve(el, h);
    return true;
  }

  function start() {
    var list = rows();
    if (list.length <= EAGER) return;

    // înălțimea de rezervat: cât ocupă un rând deja randat, ca pagina să nu se scurteze
    // sub tine și să nu-ți sară derularea când punem produsele la loc
    var sample = list[0].offsetHeight;
    var h = sample > 120 ? sample : 340;

    var asleep = [];
    for (var i = EAGER; i < list.length; i++) {
      if (sleep(list[i], h)) asleep.push(list[i]);
    }
    if (!asleep.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      asleep.forEach(wake);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          wake(en.target);
        });
      },
      { rootMargin: MARGIN }
    );
    asleep.forEach(function (el) {
      io.observe(el);
    });
  }

  // Pornim imediat, nu la DOMContentLoaded. Scriptul e „defer”, deci se execută după ce
  // s-a terminat de citit pagina dar înainte de DOMContentLoaded — adică exact înaintea
  // momentului în care tema își pornește caruselele. Dacă am aștepta același eveniment,
  // ea ar apuca prima (și-a pus ascultătorul mai devreme) și n-am mai economisi nimic.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();